// extracted by mini-css-extract-plugin
module.exports = {"headerContent":"_3lNDVD","content":"_2qBbQ-","side":"_20HXu9","logo":"_3OQawO","right":"AO4NI1"};